import { render, staticRenderFns } from "./IndividualJDModal.vue?vue&type=template&id=0dfbfda6&scoped=true&"
import script from "./IndividualJDModal.vue?vue&type=script&lang=js&"
export * from "./IndividualJDModal.vue?vue&type=script&lang=js&"
import style0 from "./IndividualJDModal.vue?vue&type=style&index=0&id=0dfbfda6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dfbfda6",
  null
  
)

export default component.exports